var _style, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWenMoonBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "moon-alt-4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 666.7 667.1",
    style: {
      enableBackground: "new 0 0 666.7 667.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2159D1;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:66.6667;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:133.3333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "secondary-fill",
    className: "st0",
    d: "M628.4,423.1L628.4,423.1c-29.8,139.6-186.1,232-349.1,206.5 C153.4,609.8,56,524,36.7,415.6l0,0c29.9-139.6,186.2-231.9,349.2-206.4C511.8,229,609.1,315,628.4,423.3V423.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "primary-stroke",
    className: "st1",
    d: "M633.4,333.4c0,18.2-1.6,36.4-5,54.3l0,0c-29.8,163-186.1,270.9-349.1,241.1 C153.4,605.8,56,505.5,36.7,379l0,0c-2.3-15.1-3.4-30.4-3.3-45.7c0-165.7,134.3-300,300-300S633.4,167.7,633.4,333.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWenMoonBadge);
export default __webpack_public_path__ + "static/media/wen_moon_badge.e3c2bab4cac6b24f91e3ecbc60497d53.svg";
export { ForwardRef as ReactComponent };